__turbopack_context__.v({
  "perkIconContainer": "YourPerks-module__2bXnqa__perkIconContainer",
  "perkItemContainer": "YourPerks-module__2bXnqa__perkItemContainer",
  "perkTextContainer": "YourPerks-module__2bXnqa__perkTextContainer",
  "perksContainer": "YourPerks-module__2bXnqa__perksContainer",
  "perksContent": "YourPerks-module__2bXnqa__perksContent",
  "perksInnerContent": "YourPerks-module__2bXnqa__perksInnerContent",
});
